import { Box, Button, Typography } from '@mui/material';
import { deleteObjectApi, putUpdateObjectApi } from 'api/general';
import { postMoveDecisionFilesApi } from 'api/meeting';
import { groupAgendasByDepartment, subjectGroupsFromAgendas, updateSortedAgendaList } from 'app/utils/appHelpers';
import { DECISION } from 'app/utils/constants/customConstant';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAllMeetingList, setAllMMList, setCurrentAgenda, setCurrentAgendaList } from 'stores/meeting';
import Swal from 'sweetalert2';
import AddPendingAgendaDialog from '../Dialog/AddPendingAgendaDialog';
import AddUpdateAgendaDialog from '../Dialog/AddUpdateAgendaDialog';
import AgendaDepartmentCard from './AgendaDepartmentCard';
import AgendaSubjectCard from './AgendaSubjectCard';


function AgendaCardListYK() {

    const [data, setData] = useState([]);
    const dispatch = useDispatch();
    const [addAgendaDialogStatus, setAddAgendaDialogStatus] = useState(false);
    const [pendingAgendaDialogStatus, setPendingAgendaDialogStatus] = useState(false);
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const { authUser } = useSelector((state) => state.auth);
    const [departmentGroups, setDepartmentGroups] = useState([]);
    let allMeetingList = useSelector((state) => state.meeting.allMeetingList);
    let allMMList = useSelector((state) => state.meeting.allMMList);
    const [extraGroup, setExtraGroup] = useState([]);

    const closeDialog = () => {
        setAddAgendaDialogStatus(false);
    };
    const updateAgenda = () => {
        setAddAgendaDialogStatus(true)
        dispatch(setCurrentAgenda(null));
    }
    const addPendingAgenda = () => {
        setPendingAgendaDialogStatus(true)
        dispatch(setCurrentAgenda(null));
    }

    const currentAgendaList = useSelector((state) => state.meeting.currentAgendaList);


    // 1) Her değişmede normal + ek gündemleri ayır
    useEffect(() => {
        const extras = currentAgendaList.filter(a => a.supp === 'Evet');
        const normals = currentAgendaList.filter(a => a.supp !== 'Evet');
        setDepartmentGroups(groupAgendasByDepartment(normals));
        setExtraGroup(extras);
        setData(currentAgendaList);

    }, [currentAgendaList]);


    const handleDepartmentSorting = async (index, direction) => {

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });


        const newDeptGroups = [...departmentGroups];
        if (direction === 'up' && index > 0) {
            [newDeptGroups[index - 1], newDeptGroups[index]] =
                [newDeptGroups[index], newDeptGroups[index - 1]];
        } else if (direction === 'down' && index < newDeptGroups.length - 1) {
            [newDeptGroups[index], newDeptGroups[index + 1]] =
                [newDeptGroups[index + 1], newDeptGroups[index]];
        }

        setDepartmentGroups(newDeptGroups);

        // sadece normal gündemler
        const normals = newDeptGroups.flatMap(([deptKey, agendas]) => agendas);

        // EK GÜNDEMleri ekle
        const all = [
            ...normals,
            ...extraGroup
        ];

        dispatch(await updateSortedAgendaList(all, "index", [], true));
    };


    const handleSubjectSortingInDept = async (deptKey, subjectIndex, direction) => {

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });


        const deptGroup = departmentGroups.find(([key]) => key === deptKey);
        if (!deptGroup) return;
        let [, agendas] = deptGroup;

        const subjectMap = agendas.reduce((acc, a) => {
            (acc[a.subjectId] = acc[a.subjectId] || []).push(a);
            return acc;
        }, {});
        let subjectGroupsArr = Object.entries(subjectMap)
            .sort((a, b) => a[1][0].decisionNo - b[1][0].decisionNo);

        // swap
        if (direction === 'up' && subjectIndex > 0) {
            [subjectGroupsArr[subjectIndex - 1], subjectGroupsArr[subjectIndex]] =
                [subjectGroupsArr[subjectIndex], subjectGroupsArr[subjectIndex - 1]];
        } else if (direction === 'down' && subjectIndex < subjectGroupsArr.length - 1) {
            [subjectGroupsArr[subjectIndex], subjectGroupsArr[subjectIndex + 1]] =
                [subjectGroupsArr[subjectIndex + 1], subjectGroupsArr[subjectIndex]];
        }

        // tek diziye döndür
        const newDeptAgendas = subjectGroupsArr.flatMap(([_, ags]) => ags);
        const newDeptGroups = departmentGroups.map(([dKey, ags]) =>
            dKey === deptKey ? [dKey, newDeptAgendas] : [dKey, ags]
        );
        setDepartmentGroups(newDeptGroups);

        const normals = newDeptGroups.flatMap(([dKey, ags]) => ags);
        const all = [
            ...normals,
            ...extraGroup
        ];
        dispatch(await updateSortedAgendaList(all, "index", [], true));
    };


    // ── EK GÜNDEM: Departman sıralama (YK için) ──
    const handleExtraDepartmentSorting = async (index, direction) => {

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: { container: 'swal-container-custom' },
            didOpen: () => Swal.showLoading()
        });

        // Ek gündemleri departmana göre gruplandır
        const extraDeptGroups = groupAgendasByDepartment(extraGroup);
        const newDeptGroups = [...extraDeptGroups];

        if (direction === 'up' && index > 0) {
            [newDeptGroups[index - 1], newDeptGroups[index]] = [newDeptGroups[index], newDeptGroups[index - 1]];
        } else if (direction === 'down' && index < newDeptGroups.length - 1) {
            [newDeptGroups[index], newDeptGroups[index + 1]] = [newDeptGroups[index + 1], newDeptGroups[index]];
        }

        // Düz diziye çevir
        const newExtra = newDeptGroups.flatMap(([, ags]) => ags);
        setExtraGroup(newExtra);

        const normals = departmentGroups.flatMap(([, ags]) => ags);
        const all = [...normals, ...newExtra];
        dispatch(await updateSortedAgendaList(all, "index", [], true));
    };

    // ── EK GÜNDEM: Departman içi konu (subject) sıralama (YK için) ──
    const handleExtraSubjectSortingInDept = async (deptKey, subjectIndex, direction) => {

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: { container: 'swal-container-custom' },
            didOpen: () => Swal.showLoading()
        });

        const extraDeptGroups = groupAgendasByDepartment(extraGroup);
        const deptGroup = extraDeptGroups.find(([key]) => key === deptKey);
        if (!deptGroup) return;
        let [, agendas] = deptGroup;

        // subject grupları
        const subjectMap = agendas.reduce((acc, a) => { (acc[a.subjectId] = acc[a.subjectId] || []).push(a); return acc; }, {});
        let subjectGroupsArr = Object.entries(subjectMap).sort((a, b) => a[1][0].decisionNo - b[1][0].decisionNo);

        if (direction === 'up' && subjectIndex > 0) {
            [subjectGroupsArr[subjectIndex - 1], subjectGroupsArr[subjectIndex]] = [subjectGroupsArr[subjectIndex], subjectGroupsArr[subjectIndex - 1]];
        } else if (direction === 'down' && subjectIndex < subjectGroupsArr.length - 1) {
            [subjectGroupsArr[subjectIndex], subjectGroupsArr[subjectIndex + 1]] = [subjectGroupsArr[subjectIndex + 1], subjectGroupsArr[subjectIndex]];
        }

        // departman içi yeni dizi
        const newDeptAgendas = subjectGroupsArr.flatMap(([, ags]) => ags);
        // tüm extraGroup'u güncelle (yalnızca ilgili departmanı değiştir)
        const rebuiltExtra = extraDeptGroups.map(([dKey, ags]) => dKey === deptKey ? [dKey, newDeptAgendas] : [dKey, ags]);
        const newExtra = rebuiltExtra.flatMap(([, ags]) => ags);
        setExtraGroup(newExtra);

        const normals = departmentGroups.flatMap(([, ags]) => ags);
        const all = [...normals, ...newExtra];
        dispatch(await updateSortedAgendaList(all, "index", [], true));
    };

    // ── EK GÜNDEM: Subject grubu sıralama (YK dışı) ──
    const handleExtraSubjectSorting = async (subjectIndex, direction) => {

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: { container: 'swal-container-custom' },
            didOpen: () => Swal.showLoading()
        });

        const subjectGroups = subjectGroupsFromAgendas(extraGroup);
        let newGroups = [...subjectGroups];

        if (direction === 'up' && subjectIndex > 0) {
            [newGroups[subjectIndex - 1], newGroups[subjectIndex]] = [newGroups[subjectIndex], newGroups[subjectIndex - 1]];
        } else if (direction === 'down' && subjectIndex < newGroups.length - 1) {
            [newGroups[subjectIndex], newGroups[subjectIndex + 1]] = [newGroups[subjectIndex + 1], newGroups[subjectIndex]];
        }

        const newExtra = newGroups.flatMap(([, ags]) => ags);
        setExtraGroup(newExtra);

        const normals = departmentGroups.flatMap(([, ags]) => ags);
        const all = [...normals, ...newExtra];
        dispatch(await updateSortedAgendaList(all, "index", [], true));
    };

    // 3) Departman içi gündem sıralaması:
    const handleAgendaSortingInDept = async (deptKey, subjectId, agendaIndex, direction, updatedAgenda) => {



        const deptGroup = departmentGroups.find(([key]) => key === deptKey);
        if (!deptGroup) return;


        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });
        let [, agendas] = deptGroup;

        // konu grubu dizisine
        const subjectMap = agendas.reduce((acc, a) => {
            (acc[a.subjectId] = acc[a.subjectId] || []).push(a);
            return acc;
        }, {});
        let subjectGroupsArr = Object.entries(subjectMap)
            .sort((a, b) => a[1][0].decisionNo - b[1][0].decisionNo);

        // hedef grubun indeksi
        const gi = subjectGroupsArr.findIndex(([sid]) => sid == subjectId);
        if (gi === -1) return;

        let group = [...subjectGroupsArr[gi][1]];
        // manuel veya ok tuşu
        if (direction === 'none') {
            const targetIdx = updatedAgenda.decisionNo - 1;
            group = group.filter(a => a.id !== updatedAgenda.id);
            group.splice(targetIdx, 0, updatedAgenda);
        } else if (direction === 'up' && agendaIndex > 0) {
            [group[agendaIndex - 1], group[agendaIndex]] =
                [group[agendaIndex], group[agendaIndex - 1]];
        } else if (direction === 'down' && agendaIndex < group.length - 1) {
            [group[agendaIndex], group[agendaIndex + 1]] =
                [group[agendaIndex + 1], group[agendaIndex]];
        }

        subjectGroupsArr[gi][1] = group;
        const newDeptAgendas = subjectGroupsArr.flatMap(([_, ags]) => ags);
        const newDeptGroups = departmentGroups.map(([dKey, ags]) =>
            dKey === deptKey ? [dKey, newDeptAgendas] : [dKey, ags]
        );
        setDepartmentGroups(newDeptGroups);

        const normals = newDeptGroups.flatMap(([dKey, ags]) => ags);
        const all = [
            ...normals,
            ...extraGroup
        ];
        dispatch(await updateSortedAgendaList(all, "index", [], true));
    };



    // ── EK GÜNDEM: Departman içi tek tek gündem sıralama (YK için) ──
    const handleExtraAgendaSortingInDept = async (deptKey, subjectId, agendaIndex, direction, updatedAgenda) => {

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: { container: 'swal-container-custom' },
            didOpen: () => Swal.showLoading()
        });

        const extraDeptGroups = groupAgendasByDepartment(extraGroup);
        const deptGroup = extraDeptGroups.find(([key]) => key === deptKey);
        if (!deptGroup) return;
        let [, agendas] = deptGroup;

        // subject grupları
        const subjectMap = agendas.reduce((acc, a) => {
            (acc[a.subjectId] = acc[a.subjectId] || []).push(a);
            return acc;
        }, {});
        let subjectGroupsArr = Object.entries(subjectMap)
            .sort((a, b) => a[1][0].decisionNo - b[1][0].decisionNo);

        const gi = subjectGroupsArr.findIndex(([sid]) => sid == subjectId);
        if (gi === -1) return;

        let group = [...subjectGroupsArr[gi][1]];
        if (direction === 'none') {
            const targetIdx = updatedAgenda.decisionNo - 1;
            group = group.filter(a => a.id !== updatedAgenda.id);
            group.splice(targetIdx, 0, updatedAgenda);
        } else if (direction === 'up' && agendaIndex > 0) {
            [group[agendaIndex - 1], group[agendaIndex]] = [group[agendaIndex], group[agendaIndex - 1]];
        } else if (direction === 'down' && agendaIndex < group.length - 1) {
            [group[agendaIndex], group[agendaIndex + 1]] = [group[agendaIndex + 1], group[agendaIndex]];
        }

        subjectGroupsArr[gi][1] = group;
        const newDeptAgendas = subjectGroupsArr.flatMap(([, ags]) => ags);

        // extraGroup'u yeni departman sırası ile yeniden kur
        const rebuiltExtra = extraDeptGroups.map(([dKey, ags]) => dKey === deptKey ? [dKey, newDeptAgendas] : [dKey, ags]);
        const newExtra = rebuiltExtra.flatMap(([, ags]) => ags);
        setExtraGroup(newExtra);

        const normals = departmentGroups.flatMap(([, ags]) => ags);
        const all = [...normals, ...newExtra];
        dispatch(await updateSortedAgendaList(all, "index", [], true));
    };

    // ── EK GÜNDEM: Subject içi tek tek gündem sıralama (YK dışı) ──
    const handleExtraAgendaSorting = async (subjectId, agendaIndex, direction, updatedAgenda) => {

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: { container: 'swal-container-custom' },
            didOpen: () => Swal.showLoading()
        });

        const subjectGroups = subjectGroupsFromAgendas(extraGroup);
        const gi = subjectGroups.findIndex(([sid]) => sid == subjectId);
        if (gi === -1) return;

        let group = [...subjectGroups[gi][1]];
        if (direction === 'none') {
            const targetIdx = updatedAgenda.decisionNo - 1;
            group = group.filter(a => a.id !== updatedAgenda.id);
            group.splice(targetIdx, 0, updatedAgenda);
        } else if (direction === 'up' && agendaIndex > 0) {
            [group[agendaIndex - 1], group[agendaIndex]] = [group[agendaIndex], group[agendaIndex - 1]];
        } else if (direction === 'down' && agendaIndex < group.length - 1) {
            [group[agendaIndex], group[agendaIndex + 1]] = [group[agendaIndex + 1], group[agendaIndex]];
        }

        subjectGroups[gi][1] = group;
        const newExtra = subjectGroups.flatMap(([, ags]) => ags);
        setExtraGroup(newExtra);

        const normals = departmentGroups.flatMap(([, ags]) => ags);
        const all = [...normals, ...newExtra];
        dispatch(await updateSortedAgendaList(all, "index", [], true));
    };

    // Agenda silme işlemi
    const handleDelete = async (item, type = "agenda") => {

        const confirmTitle = type === 'pending' ? 'Askıya Alma İşlemi' : 'Silme İşlemi';
        const confirmText = type === 'pending' ? 'Askıya alma işlemini onaylıyor musunuz?' : 'Silme işlemini onaylıyor musunuz?';
        const confirmResult = await Swal.fire({
            title: confirmTitle,
            text: confirmText,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Evet',
            cancelButtonText: 'Vazgeç',
            customClass: { container: 'swal-container-custom' }
        });
        if (!confirmResult.isConfirmed) {
            return;
        }

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });

        let updatedList = [];

        if (type === "agenda") {
            const result = await deleteObjectApi(DECISION, item.id);
            if (result.status) {

                const sortedAgendaList = [...data].sort((a, b) => a.decisionNo - b.decisionNo);
                const filteredList = sortedAgendaList.filter(x => x.id !== item.id);


                if (filteredList.length > 0) {
                    updatedList = filteredList.map((agenda, index) => ({
                        ...agenda,
                        decisionNo: index + 1,
                    }));
                    await dispatch(await updateSortedAgendaList(updatedList, "", [], true));

                } else {
                    dispatch(setCurrentAgendaList([]));
                }


            } else {
                Swal.close();
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Silme işlemi başarısız',
                    showConfirmButton: false,
                    timer: 2000,
                    customClass: {
                        container: 'swal-container-custom'
                    },
                });
                return;
            }


        } else if (type === "pending") {

            let { user, ...pendingAgenda } = item;

            pendingAgenda = {
                ...pendingAgenda,
                meetingId: -1,
                pendingUnitId: currentMeeting.unitId
            }
            const result = await putUpdateObjectApi(DECISION, pendingAgenda);


            if (result.status) {

                const sortedAgendaList_ = [...data].sort((a, b) => a.decisionNo - b.decisionNo);
                const filteredList = sortedAgendaList_.filter(x => x.id !== item.id);


                if (filteredList.length > 0) {
                    updatedList = filteredList.map((agenda, index) => ({
                        ...agenda,
                        decisionNo: index + 1,
                    }));

                    await dispatch(await updateSortedAgendaList(updatedList, "", [], true));

                } else {
                    dispatch(setCurrentAgendaList([]));
                }

            } else {
                Swal.close();
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Silme işlemi başarısız',
                    showConfirmButton: false,
                    timer: 2000,
                    customClass: {
                        container: 'swal-container-custom'
                    },
                });

                return;
            }

        }

        Swal.close();

        allMeetingList = allMeetingList.map(meeting => {
            if (meeting.id === currentMeeting.id) {
                return {
                    ...meeting,
                    user: authUser,
                    adminUserId: authUser.id,
                    decisionCount: updatedList.length
                };
            }
            return meeting;
        });

        allMMList = allMMList.map(meeting => {
            if (meeting.id === currentMeeting.id) {
                return {
                    ...meeting,
                    user: authUser,
                    adminUserId: authUser.id,
                    decisionCount: updatedList.length
                };
            }
            return meeting;
        });
        dispatch(setAllMeetingList(allMeetingList));
        dispatch(setAllMMList(allMMList));

        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Silme işlemi başarılı.',
            showConfirmButton: false,
            timer: 2000,
            customClass: {
                container: 'swal-container-custom'
            },
        });

    };


    const handleAddPendingAgenda = async (agendaItem) => {
        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });
        let newAgenda = { ...agendaItem };
        if (!newAgenda.decision || (typeof newAgenda.decision === "string" && newAgenda.decision.trim() === "")) {
            newAgenda.decision = newAgenda.agenda;
        }
        newAgenda.meetingId = currentMeeting.id;
        newAgenda.adminUserId = authUser.id;
        newAgenda.agenda = agendaItem.agenda;
        newAgenda.decision = agendaItem.decision;
        newAgenda.pdate = new Date();
        newAgenda.decisionNo = 1;
        const result = await putUpdateObjectApi(DECISION, newAgenda);

        if (result.status) {
            try {
                const moveResult = await postMoveDecisionFilesApi({
                    decisionId: agendaItem.id,
                    newMeetingId: currentMeeting.id,
                    newInst: currentMeeting.inst
                });

                if (!moveResult.status) {
                    const { user, ...revertAgenda } = agendaItem;
                    await putUpdateObjectApi(DECISION, revertAgenda);
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Dosya taşıma sırasında hata oluştu. İşlem geri alındı.',
                        showConfirmButton: true,
                        customClass: { container: 'swal-container-custom' },
                    });
                    return;
                }
            } catch (err) {
                const { user, ...revertAgenda } = agendaItem;
                await putUpdateObjectApi(DECISION, revertAgenda);
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Dosya taşıma sırasında hata oluştu. İşlem geri alındı.',
                    showConfirmButton: true,
                    customClass: { container: 'swal-container-custom' },
                });
                return;
            }

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Ekleme başarılı.',
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    container: 'swal-container-custom'
                },
            });

            newAgenda.user = authUser;
            dispatch(await updateSortedAgendaList(currentAgendaList, "change", { id: result.data.insertId, ...newAgenda }, true));


            allMeetingList = allMeetingList.map(meeting => {
                if (meeting.id === currentMeeting.id) {
                    return {
                        ...meeting,
                        decisionCount: currentAgendaList.length + 1,
                        user: authUser,
                        adminUserId: authUser.id
                    };
                }
                return meeting;
            });

            allMMList = allMMList.map(meeting => {
                if (meeting.id === currentMeeting.id) {
                    return {
                        ...meeting,
                        decisionCount: currentAgendaList.length + 1,
                        user: authUser,
                        adminUserId: authUser.id
                    };
                }
                return meeting;
            });

            dispatch(setAllMeetingList(allMeetingList));
            dispatch(setAllMMList(allMMList));
            setPendingAgendaDialogStatus(false)
        }
    };


    return (
        <>


            <div style={{ margin: 5, padding: 0, textAlign: 'right', width: '99%' }}>


                <Button
                    key="addAgenda"
                    variant="outlined"
                    color='inherit'
                    size="small"
                    onClick={() => updateAgenda()}
                >
                    Gündem Ekle
                </Button>
                <Button
                    key="pendingAgenda"
                    variant="outlined"
                    color='inherit'
                    size="small"
                    onClick={() => addPendingAgenda()}
                >
                    Askıdaki Gündemlerden Ekle
                </Button>
            </div>

            {currentAgendaList.length === 0 &&
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '50%',
                        color: 'black'
                    }}
                >
                    <Typography variant="h6" color="inherit">
                        Gündem Bulunmamaktadır
                    </Typography>
                </Box>
            }

            {addAgendaDialogStatus && (
                <AddUpdateAgendaDialog

                    open={addAgendaDialogStatus}
                    onClose={closeDialog}
                />
            )}

            {pendingAgendaDialogStatus && (
                <AddPendingAgendaDialog
                    handleAddPendingAgenda={handleAddPendingAgenda}
                    open={pendingAgendaDialogStatus}
                    onClose={() => setPendingAgendaDialogStatus(false)}
                />
            )}

            {departmentGroups.map(([deptKey, agendas], index) => (
                <AgendaDepartmentCard
                    key={deptKey}
                    deptKey={deptKey}
                    agendas={agendas}
                    index={index}
                    departmentGroups={departmentGroups}
                    handleDepartmentSorting={handleDepartmentSorting}
                    handleSubjectSorting={handleSubjectSortingInDept}
                    handleAgendaSorting={handleAgendaSortingInDept}
                    handleDelete={handleDelete}
                />
            ))}
            {/* ── EK GÜNDEM BÖLÜMÜ ── */}
            {extraGroup.length > 0 && (
                <>
                    <Box sx={{ mt: 1, mb: 1 }}>
                        <Typography sx={{ color: 'error.main', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                            Ek Gündemler / Gündem Sayısı: {extraGroup.length}
                        </Typography>
                    </Box>

                    {currentMeeting.inst === 'YK' ? (
                        // YK: Department → Subject gruplama
                        groupAgendasByDepartment(extraGroup).map(([deptKey, agendas], index) => (
                            <AgendaDepartmentCard
                                key={`extra-${deptKey}`}
                                deptKey={deptKey}
                                agendas={agendas}
                                index={index}
                                departmentGroups={groupAgendasByDepartment(extraGroup)}
                                handleDepartmentSorting={handleExtraDepartmentSorting}
                                handleSubjectSorting={handleExtraSubjectSortingInDept}
                                handleAgendaSorting={handleExtraAgendaSortingInDept}
                                handleDelete={handleDelete}
                            />
                        ))
                    ) : (
                        // YK dışı: Sadece Subject gruplama
                        subjectGroupsFromAgendas(extraGroup).map(([subjectId, agendas], subjIndex, arr) => (
                            <AgendaSubjectCard
                                key={`extra-subj-${subjectId}`}
                                subjectId={subjectId}
                                agendas={agendas}
                                index={subjIndex}
                                subjectGroups={arr}
                                handleSubjectSorting={handleExtraSubjectSorting}
                                handleAgendaSorting={handleExtraAgendaSorting}
                                handleDelete={handleDelete}
                                isExtra
                            />
                        ))
                    )}
                </>
            )}


        </>
    );
}
const style = document.createElement('style');
style.innerHTML = `
    .swal-container-custom {
        z-index: 10000 !important;
    }
`;
document.head.appendChild(style);

export default AgendaCardListYK;